import { render, staticRenderFns } from "./MyNotification.vue?vue&type=template&id=ebcbd658"
import script from "./MyNotification.vue?vue&type=script&lang=js"
export * from "./MyNotification.vue?vue&type=script&lang=js"
import style0 from "./MyNotification.vue?vue&type=style&index=0&id=ebcbd658&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports